import React from 'react';
import { Alert } from 'reactstrap';
import './NewsTicker.scss';

const NewsTicker = ({ 
  message = "",
  speed = 50,
  backgroundColor = "#17a2b8",
  textColor = "#ffffff",
  pauseOnHover = true,
  showIcon = true
}) => {
  return (
    <div className="news-ticker-container">
      <div 
        className="news-ticker" 
        style={{ 
          backgroundColor: backgroundColor,
          color: textColor 
        }}
      >
        <div className="news-ticker-wrapper">
          {showIcon && (
            <div className="news-ticker-icon">
              <i className="mdi mdi-bullhorn-outline"></i>
            </div>
          )}
          <div className="news-ticker-content">
            <div 
              className={`news-ticker-text ${pauseOnHover ? 'pause-on-hover' : ''}`}
              style={{ 
                animationDuration: `${speed}s`,
                color: textColor 
              }}
            >
              <span className="ticker-message">{message}</span>
              {/* Duplicate message for seamless loop */}
              <span className="ticker-message" style={{ marginLeft: '100px' }}>{message}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
